export default "__VITE_ASSET__CA01J3Iv__"